import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { about } from "../data/profile";
import { Reveal, Overline, AnimatedHeading } from "./Reveal";

const PORTRAIT =
  "https://images.unsplash.com/photo-1626315869436-d6781ba69d6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export const About = () => (
  <section id="about" className="py-16 sm:py-20 lg:py-24 bg-white border-y border-[#E2E5E1]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>About Dr. Pandya</Overline>
            <AnimatedHeading className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight mt-4 leading-snug">
              Building healthcare systems that earn trust.
            </AnimatedHeading>
          </Reveal>
          <Reveal delay={0.1} className="mt-8 rounded-2xl overflow-hidden border border-[#E2E5E1] img-zoom">
            <img src={PORTRAIT} alt="Healthcare leadership" className="w-full h-72 object-cover" />
          </Reveal>
          <Reveal delay={0.15} className="mt-8 space-y-3">
            {about.highlights.map((h, i) => (
              <motion.div
                key={h}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="flex items-start gap-3 group"
              >
                <span className="mt-0.5 h-5 w-5 rotate-45 bg-gradient-to-br from-teal to-gold flex items-center justify-center shrink-0 transition-all duration-500 group-hover:rotate-[225deg] group-hover:scale-110 shadow-sm">
                  <Check size={11} strokeWidth={3} className="text-white -rotate-45" />
                </span>
                <span className="text-sm group-hover:translate-x-1 transition-transform duration-300" style={{ color: "#4B5A69" }}>{h}</span>
              </motion.div>
            ))}
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pt-14">
          <div className="space-y-6">
            {about.paragraphs.map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.08}>
                <p className="text-lg leading-relaxed text-justify" style={{ color: "#4B5A69" }}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
